import dataReducer from './data/reducer'
import modulesReducer from './modules/reducer'
import {matchReducer} from './features/match/store'

export default {
  data: dataReducer,
  modules: modulesReducer,
  match: matchReducer,
}
